import { intl } from 'lang/intl'
import React from 'react'
import classnames from 'classnames'

import { TtButton, TtIcon } from '@23/ui-react'

import {
  switchToCustomMix,
  useFloorState,
} from '../../../../firebase/hooks/useFloor'
import {
  setEditingMix,
  useIsEditingMix,
} from '../../../../firebase/hooks/useMixes'
import type { Mix } from '../../../../firebase/model/mix'
import type { DeepReadonly } from '../../../../firebase/typeUtils'
import { debug } from '../../../../global/debug'
import { MixPreview } from '../MixPreview/MixPreview'

import './CustomMix.scss'

interface CustomMixProps {
  mix: DeepReadonly<Mix>
}

const CustomMix = ({ mix }: CustomMixProps) => {
  const floor = useFloorState()
  const isEditingMix = useIsEditingMix(mix.id)

  const isLive = floor?.layout === 'custom' && floor.mixId === mix.id

  return (
    <button
      type="button"
      className={classnames('custom-mix-trigger', {
        full: debug.participantStripFullMixPreview,
        'is-editing': isEditingMix,
      })}
      onClick={() => switchToCustomMix(mix.id)}
      data-active={isLive}
    >
      <MixPreview mix={mix} />
      <div className="custom-mix-settings-baseline">
        <div>{mix.name ?? intl.formatMessage({ defaultMessage: 'name' })}</div>
        <div className="custom-mix-settings-button-zone">
          <TtButton
            className="custom-mix-settings-button"
            color="secondary"
            variant="light"
            size="x-small"
            onClick={(event) => {
              event.stopPropagation()
              setEditingMix(mix.id)
            }}
          >
            <TtIcon library="23" name="cog" />
          </TtButton>
        </div>
      </div>
    </button>
  )
}

export { CustomMix }
